import React from "react";

import blocks, { BlockType, rawBlockTypeToBlockType } from "@/components/PowerBlock/Blocks/index";
import { ColumnType } from "@/types/evaluate";

interface HeaderIconProps {
  columnType: ColumnType;
  hasError?: boolean;
  isSelected?: boolean;
  isDraft?: boolean;
}

const getIconColorClass = ({
  hasError,
  isSelected,
  isDraft,
}: {
  hasError?: boolean;
  isSelected?: boolean;
  isDraft?: boolean;
}): string => {
  if (hasError) {
    return "text-red-500";
  }

  if (isSelected) {
    return "text-blue-500";
  }

  if (isDraft) {
    return "text-gray-400";
  }

  return "text-gray-600";
};

export const HeaderIcon = ({ columnType, hasError, isSelected, isDraft }: HeaderIconProps) => {
  const colorClass = getIconColorClass({ hasError, isSelected, isDraft });
  const iconClass = `absolute left-0 inline-block min-h-4 min-w-4 max-h-4 max-w-4 ${colorClass}`;

  const getIconForColumnType = (columnTypeToUse: ColumnType) => {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const blockType: BlockType = rawBlockTypeToBlockType(columnTypeToUse as any);

    const blockDefinition = blocks[blockType];
    if (blockDefinition?.icon) {
      const IconComponent = blockDefinition.icon;
      return <IconComponent className={iconClass} />;
    }

    return null;
  };

  return getIconForColumnType(columnType);
};
